var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaffeine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.71 61.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "allergen_icons_white",
    "data-name": "allergen icons white"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,30.86A30.86,30.86,0,1,1,30.86,61.71,30.85,30.85,0,0,1,0,30.86Zm13.32,6.22c3.05-2,5.64-5.77,8.3-9.63,2.88-4.2,5.86-8.54,9.45-10.79a1.11,1.11,0,0,0,.54-.95,1,1,0,0,0-.82-1,8,8,0,0,0-2.7-.33c-4,0-8.51,2-12.07,5.56a17.8,17.8,0,0,0-5.5,12.1,7.45,7.45,0,0,0,1.27,4.69,1,1,0,0,0,.9.51A1.18,1.18,0,0,0,13.32,37.08Zm29.48,8a6.13,6.13,0,0,0,3.66-.89,1,1,0,0,0,.47-.82,1.12,1.12,0,0,0,0-.31c-1.08-3.3-4.7-6-8.28-8.84-1.37-1.06-2.83-2-4.08-3.09.16-.28.86-1.48,1-1.77a40.56,40.56,0,0,0,4,3.24c3.15,2.45,6.37,4.86,8,7.77a1,1,0,0,0,.88.52h.07c1.12-.08,1.19-1.88,1.19-3.26,0-6.16-6.31-13.47-12.8-14A9.08,9.08,0,0,0,35.36,18a1.12,1.12,0,0,0-1-.49,1.26,1.26,0,0,0-.43.08C29.9,19.23,26.65,24,23.39,28.75c-2.6,3.79-5,7.21-7.84,9.4a1.16,1.16,0,0,0-.46.93,1.22,1.22,0,0,0,.74,1.11,8.49,8.49,0,0,0,3.48.54A17.12,17.12,0,0,0,30.46,36c2.19,4.74,7.49,9.09,12.34,9.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaffeine);
export default __webpack_public_path__ + "static/media/caffeine.feac9aef001a2af931700a0589608739.svg";
export { ForwardRef as ReactComponent };